import { useAtom } from 'jotai';

import {
  initialDataMinileague,
  InitialDataMinileague,
  minileagueDataAtom,
} from '@/store';

export const useMinileagueData = () => {
  const [miniligueData, setMiniligueData] = useAtom(minileagueDataAtom);

  const handleSetMiniligueData = (data: InitialDataMinileague) => {
    setMiniligueData(data);
  };

  const handleResetMiniligueData = () => {
    setMiniligueData(initialDataMinileague);
  };

  const updateMinileagueProperties = (
    updates: Partial<InitialDataMinileague>
  ) => {
    setMiniligueData((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  return {
    miniligueData,
    handleSetMiniligueData,
    handleResetMiniligueData,
    updateMinileagueProperties,
  };
};
